import React, { useState } from "react";
import "./ContactUs.css";
import { GoogleMap, Marker, LoadScript } from "@react-google-maps/api";
import emailjs from "@emailjs/browser";

const containerStyle = {
  width: "100%",
  height: "400px",
};

const center = {
  lat: 13.1291,
  lng: 77.7064,
};

export default function ContactUs() {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [responseMessage, setResponseMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(null);
  const [loading, setLoading] = useState(false); // NEW state

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const isValidPhone = (phone) => /^[6-9]\d{9}$/.test(phone);
  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const isFormValid =
    formData.first_name &&
    formData.last_name &&
    isValidEmail(formData.email) &&
    isValidPhone(formData.phone) &&
    formData.message;

  const sendEmail = (e) => {
    e.preventDefault();
    if (!isFormValid) return;

    setLoading(true); // disable button while sending

    emailjs
      .send(
        "service_dmngb3r",
        "template_vvh45fz",
        formData,
        "eePpcUD4HfvjW2xVz"
      )
      .then(
        () => {
          setResponseMessage("Message sent successfully!");
          setIsSuccess(true);
          setLoading(false);
        },
        () => {
          setResponseMessage("Failed to send message. Please try again.");
          setIsSuccess(false);
          setLoading(false);
        }
      );
  };

  return (
    <div className="contact-container">
      <div className="contact-form">
        <h2>Send Us a Message</h2>
        <form onSubmit={sendEmail}>
          <div className="form-group">
            <input
              type="text"
              name="first_name"
              placeholder="First Name"
              value={formData.first_name}
              onChange={handleChange}
              required
            />
            <input
              type="text"
              name="last_name"
              placeholder="Last Name"
              value={formData.last_name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              required
              className={
                formData.email && !isValidEmail(formData.email) ? "invalid" : ""
              }
            />
            <input
              type="tel"
              name="phone"
              placeholder="Phone"
              value={formData.phone}
              onChange={handleChange}
              required
              className={
                formData.phone && !isValidPhone(formData.phone) ? "invalid" : ""
              }
            />
          </div>
          {!isValidEmail(formData.email) && formData.email && (
            <p className="validation-error">Please enter a valid email address.</p>
          )}
          {!isValidPhone(formData.phone) && formData.phone && (
            <p className="validation-error">Please enter a valid 10-digit phone number.</p>
          )}

          <div className="form-group full-width">
            <textarea
              name="message"
              placeholder="Your Message"
              value={formData.message}
              onChange={handleChange}
              required
            />
          </div>
          <button
            type="submit"
            className="submit-btn"
            disabled={!isFormValid || loading} // disable if invalid or loading
          >
            {loading ? "Sending..." : "Send Message"}
          </button>
        </form>

        {responseMessage && (
          <p className={`response-message ${isSuccess ? "success" : "error"}`}>
            {responseMessage}
          </p>
        )}
      </div>

      <div className="contact-map">
        <h2>Contact Us</h2>
        <p>Reach out to us for any queries or to discuss your real estate needs.</p>
        <h3>Our Office</h3>
        <h3>India</h3>
        <p>
          09, BeeVee Building, Gare Ravi Layout,<br />
          Devanahalli, Bengaluru, Karnataka, India - 562110
        </p>
        <p>Phone: +91 9759751755</p>
        <p>Email: info@venturestoneproperties.in</p>

        <h3>Netherlands</h3>
        <p>
          2, De Groene haven,<br />
          Delft, The Netherlands - 2627CD
        </p>
        <p>Phone: +31 645059721</p>
        <p>Email: info@venturestoneproperties.in</p>

        <h3>United Kingdom</h3>
        <p>
          10, Raleigh Court<br />
          Rouen Road, Norwich, 
          Norfolk, United Kingdom - NR11XB
        </p>
        <p>Phone: +44 7438004565</p>
        <p>Email: info@venturestoneproperties.in</p>

        <LoadScript googleMapsApiKey="AIzaSyCnj0Y502v_eRLO9ULaBvoHazHdPh19Zqw">
          <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={15}>
            <Marker position={center} />
          </GoogleMap>
        </LoadScript>
      </div>
    </div>
  );
}